















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action } from '@/api/model/action'
import { ActionType } from '@/api/types'
import { User } from '@/api/model/user'

@Component
export default class CalendarAction extends Vue {
    @Prop({ required: true }) action!: Action
    @Prop({ required: true }) view!: string

    colorForAction(action: Action): string {
        if (action.type === ActionType.MEETING) {
            return 'purple'
        } else {
            return 'blue'
        }
    }

    classesForAction(action: Action): string[] {
        return [
            `bg-${this.colorForAction(action)}-100`,
        ]
    }

    iconForAction(action: Action): string {
        if (action.type === ActionType.MEETING) {
            // Determine icon based on appointment type
            switch (action.appointmentType) {
                case 'video': return 'icon-meeting-action-video'
                case 'phone': return 'icon-phone-retro'
                case 'office': return 'icon-meeting-action-office'
                case 'customer': return 'icon-meeting-action-customer'
                default: return 'icon-meeting-action'
            }
        } else {
            // Determine icon based on type
            switch (action.type) {
                // case 'meeting': return 'icon-meeting-action'
                case 'email': return 'icon-email-action'
                case 'call': return 'icon-call-action'
                case 'reminder': return 'icon-reminder-action'
                case 'letter': return 'icon-letter-action'
                case 'billing': return 'icon-billing'
                case 'update': return 'icon-update-action'
                case 'notification': return 'icon-reminder-action'
                default: return 'icon-task-action'
            }
        }
    }

    iconClassesForAction(action: Action): string[] {
        return [
            `bg-white`,
            `text-${this.colorForAction(action)}-600`,
        ]
    }

    classesForUser(action: Action, user: User) {
        if (user.id === this.$currentUser.id) {
            return [
                `text-${this.colorForAction(action)}-600`,
                `font-bold`,
            ]
        }

        return []
    }
}
